export default __webpack_public_path__ + "static/media/uploader-abbottXtra-3.2b0c964a.png";